module.exports = __webpack_public_path__ + "img/va_lang.32b63f18.png";